export default __webpack_public_path__ + "static/media/bob.9eb9236c.jpg";